export default __webpack_public_path__ + "static/media/RPG_8.7c57f2be.png";